import React, { useEffect } from 'react';
import './Hero.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
const Hero = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 , once : false});
  }, []);
  return (
    <section id="hero" className="hero">
      <video autoPlay muted loop className="hero-video">
        <source src="/Images/Amar & Hiral Teaser 4k 3.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="hero-overlay" />
      <div className="hero-content" data-aos="fade-up">
        <h1 data-aos="fade-down">Capture Life’s Unforgettable Moments 📸🎥</h1>
        <p data-aos="fade-up" data-aos-delay="200">
          Professional photography, videography, and video editing services for weddings, events, portraits & more.
        </p>
        <a
          href="mailto:rdoshi1997@gmail.com?subject=Session%20Booking&body=Hi%2C%20I%27d%20like%20to%20schedule%20a%20photography%20session."
          className="cta-button"
          data-aos="zoom-in"
          data-aos-delay="400"
        >
          📧 Email to Schedule Your Session
        </a>
      </div>
    </section>
  );
};
export default Hero;